import { PnL, fmt, Table, Td } from "../../../components/dashboard/Shared";

const REASON = {
  sl_hit: ["SL HIT", "text-[#FF3B30] bg-[#FF3B30]/10"], tp_hit: ["TP HIT", "text-[#00E676] bg-[#00E676]/10"],
  stop_out: ["STOP OUT", "text-[#FF3B30] bg-[#FF3B30]/10"], manual: ["MANUAL", "text-[#FFD600] bg-[#FFD600]/10"],
  expert: ["EA/API", "text-[#00F0FF] bg-[#00F0FF]/10"], unknown: ["—", "text-gray-500 bg-white/5"],
};
export const SourceTag = ({ source }) => (
  <span data-testid={`source-${source}`} className={`text-[10px] px-1.5 py-0.5 rounded font-medium ${source === "chartzfx" ? "text-[#7000FF] bg-[#7000FF]/15 border border-[#7000FF]/40" : source === "manual" ? "text-[#FFD600] bg-[#FFD600]/10" : "text-gray-500 bg-white/5"}`}>
    {source === "chartzfx" ? "CHARTZFX" : source === "manual" ? "CLIENT" : "UNKNOWN"}
  </span>
);

const t = (iso) => (iso ? String(iso).slice(0, 16).replace("T", " ") : "—");

export const TradesTable = ({ trades }) => {
  if (!trades.length) return <p className="text-sm text-gray-500 py-8 text-center" data-testid="trades-empty">No closed trades in this period.</p>;
  return (
    <Table headers={["Closed", "Symbol", "Side", "Lots", "Open", "Close", "SL", "TP", "Exit", "Source", "Swap", "Comm.", "P/L"]} testId="client-trades-table">
      {trades.map((x) => {
        const [rl, rc] = REASON[x.exit_reason] || REASON.unknown;
        return (
          <tr key={x.trade_id} data-testid={`trade-row-${x.trade_id}`} className="border-b border-white/5 hover:bg-white/[0.03]">
            <Td className="text-xs tabular">{t(x.close_time)}</Td>
            <Td className="text-white text-xs">{x.symbol}</Td>
            <Td><span className={`text-[11px] uppercase ${x.type === "buy" ? "text-[#00E676]" : "text-[#FF3B30]"}`}>{x.type}</span></Td>
            <Td className="tabular text-xs">{fmt(x.volume)}</Td>
            <Td className="tabular text-xs">{x.open_price ?? "—"}</Td>
            <Td className="tabular text-xs">{x.close_price ?? "—"}</Td>
            <Td className="tabular text-xs text-[#FF3B30]/80">{x.sl ?? "—"}</Td>
            <Td className="tabular text-xs text-[#00E676]/80">{x.tp ?? "—"}</Td>
            <Td><span className={`text-[10px] px-1.5 py-0.5 rounded ${rc}`}>{rl}</span></Td>
            <Td><SourceTag source={x.source} /></Td>
            <Td className="tabular text-xs text-gray-500">{fmt(x.swap)}</Td>
            <Td className="tabular text-xs text-gray-500">{fmt(x.commission)}</Td>
            <Td><PnL value={x.profit || 0} /></Td>
          </tr>
        );
      })}
    </Table>
  );
};

export const DailyTable = ({ daily }) => {
  if (!daily.length) return null;
  return (
    <Table headers={["Date", "Trades", "Wins", "Losses", "Win %", "Lots", "SL hits", "TP hits", "Profit", "Loss", "Net"]} testId="client-daily-table">
      {daily.map((d) => (
        <tr key={d.date} className="border-b border-white/5" data-testid={`daily-row-${d.date}`}>
          <Td className="text-white text-xs tabular">{d.date}</Td>
          <Td className="tabular">{d.trades}</Td>
          <Td className="tabular text-[#00E676]">{d.wins}</Td>
          <Td className="tabular text-[#FF3B30]">{d.losses}</Td>
          <Td className="tabular">{d.win_rate}%</Td>
          <Td className="tabular">{fmt(d.lots)}</Td>
          <Td className="tabular">{d.sl_hits}</Td>
          <Td className="tabular">{d.tp_hits}</Td>
          <Td className="tabular text-[#00E676]">{fmt(d.gross_profit)}</Td>
          <Td className="tabular text-[#FF3B30]">{fmt(d.gross_loss)}</Td>
          <Td><PnL value={d.net} /></Td>
        </tr>
      ))}
    </Table>
  );
};

export const FundingTable = ({ funding }) => {
  if (!funding.length) return <p className="text-sm text-gray-500 py-6 text-center" data-testid="funding-empty">No deposits / withdrawals in this period.</p>;
  return (
    <Table headers={["Time", "Type", "Amount", "Comment"]} testId="client-funding-table">
      {funding.map((f) => (
        <tr key={f.deal_id} className="border-b border-white/5">
          <Td className="text-xs tabular">{t(f.time)}</Td>
          <Td><span className={`text-[11px] uppercase ${f.kind === "deposit" ? "text-[#00E676]" : f.kind === "withdrawal" ? "text-[#FF3B30]" : "text-gray-300"}`}>{f.kind}</span></Td>
          <Td><PnL value={f.amount} /></Td>
          <Td className="text-xs text-gray-500">{f.comment || "—"}</Td>
        </tr>
      ))}
    </Table>
  );
};
